import L from 'leaflet';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import autosize from 'autosize';
import Mousetrap from 'mousetrap';
import intl from 'react-intl-universal';

import ThumbRating from "../ThumbRating";
import StarRating from "../StarRating";

import './EditModal.css';

@observer
class EditModal extends Component {
    componentDidMount = (e) => {
        autosize(this.textarea);
        Mousetrap.bind(['enter'], this.props.handleSave);
        Mousetrap.bind(['backspace'], this.props.handleDeleteConfirmation);
        //NOTE: unclear why this code was needed, disabling as it is breaking click after modal... L.DomEvent.disableClickPropagation(this.wrapperDOMref);
        //hacky solution
        if (this.props.appStore.isMobile) {
            //TEMP L.DomEvent.disableClickPropagation(this.wrapperDOMref);
            //on mobile this line prevents this error 'unable to preventdefault inside passive listener'
            //on desktop this prevents user adding marker on first click and user doesnt have to click twice when editing
        }
    };
    componentWillUnmount = () => {
        Mousetrap.unbind(['enter'], this.props.handleSave);
        Mousetrap.unbind(['backspace'], this.props.handleDeleteConfirmation);
    };
    handleTextChange = (e) => {
        this.props.appStore.setPendingElementText(e.target.value);
    };

    handleCancel = () => {
        if (!this.props.appStore.pendingState.editing) {
            this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        }
        this.props.appStore.clearPending();
    };

    getEditTitle = (editing, elementTypeText) => {
        let iconText;

        switch (elementTypeText){
            case ('polygon'):
                iconText = intl.get("polygon");
                break;
            case ('marker'):
                iconText = intl.get("icon");
                break;
            case ('polyline'):
                iconText = intl.get("polyline");
                break;
        }

        if (editing) {
            return intl.get("EditModal.editTitle", {icon_type: iconText});
        }
        return intl.get("EditModal.addTitle", {icon_type: iconText});
    };

    render() {
        if (!this.props.appStore.pendingState.element) {
            return null;
        }
        let elementTypeText = this.props.appStore.pendingState.element.type;

        return (
            <div className="EditModal" ref={ref => this.wrapperDOMref = ref}>
                <div>
                    <h4>{this.getEditTitle(this.props.appStore.pendingState.editing, elementTypeText)}</h4>

                    {this.props.appStore.pendingState.element.icon.extra === "thumbs" &&
                        <ThumbRating appStore={this.props.appStore}/>
                    }
                    {this.props.appStore.pendingState.element.icon.extra === "stars" &&
                        <StarRating appStore={this.props.appStore}/>
                    }

                    {this.props.appStore.pendingState.element.icon.commentBox &&
                        <div>
                            <label htmlFor="comment-box">{this.props.appStore.pendingState.element.icon.commentPrompt ? this.props.appStore.pendingState.element.icon.commentPrompt : intl.get("EditModal.commentTitle", {icon_type: elementTypeText})}</label>
                            <textarea ref={c => this.textarea = c} onChange={this.handleTextChange} name="comment-box"
                                      value={this.props.appStore.pendingState.element.text} rows={2}
                                      placeholder={intl.get("EditModal.textarea_placeholder")}/>
                        </div>}

                    <div className="buttons">
                        {this.props.appStore.pendingState.editing &&
                        <button className="delete" onClick={this.props.handleDeleteConfirmation}>
                            {intl.get("EditModal.delete")}
                        </button>
                        }

                        <button className="cancel" onClick={this.handleCancel}>
                            {intl.get("EditModal.cancel")}
                        </button>

                        <button className="save" onClick={this.props.handleSave}>
                            {intl.get("EditModal.save")}
                        </button>


                    </div>
                </div>
            </div>
        );
    }
}

export default EditModal;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/components/EditModal/index.js